import HomePage from '../components/HomePage';

const HomePageContainer = HomePage;

export default HomePageContainer;
